export default __webpack_public_path__ + "static/media/P20017.ade7991f.png";